import type { PollQuestion } from './AsidePollModal.types';

export const tariffSelectionQuestions: PollQuestion[] = [
    {
        analyticsId: 'type_files',
        title: 'Каких файлов у вас больше всего?',
        variants: ['Фотографий', 'Видео', 'Документов'],
    },
    {
        analyticsId: 'ad_opinion',
        title: 'Что думаете насчёт рекламы в Облаке?',
        variants: ['Раздражает', 'Она есть, но не мешает', 'Я её не замечаю'],
    },
    {
        analyticsId: 'count_files',
        title: 'Для чего используете Облако?',
        variants: ['Пользуюсь для учёбы', 'Храню личные фото и видео', 'Для работы или хобби'],
    },
    {
        analyticsId: 'function',
        title: 'Какие функции важны для вас?',
        variants: [
            'Приоритетная помощь от\u00A0службы поддержки',
            'Загрузка и отправка больших файлов',
            'Возможность поделиться своей подпиской с близкими',
            'Уведомления, что моё письмо в Почте прочитали',
        ],
        multiple: true,
    },
];
